@if(mode==="edit" || mode==="add"){

<div class="ppl-mt20">
  <form nz-form nz-row [formGroup]="viewerForm" class="ppl-p0">
    @if(mode==="edit") {
    <div nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24">
          Association Type
        </nz-form-label>

        <nz-form-label [nzSm]="8" [nzXs]="24">
          {{selectedViewer.displayAssociationType}}
        </nz-form-label>
      </nz-row>
    </div>

    <div nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24">
          Entity
        </nz-form-label>

        <nz-form-label [nzSm]="8" [nzXs]="24">
          {{selectedViewer.viewerValue}}
        </nz-form-label>
      </nz-row>
    </div>
    }
    @if(mode==="add" && isAttrAvailable('mcoOrgName') && viewerType === 'MCO'){
    <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="mcoOrgName" class="ppl-form-label"
          [authorizeField]="[pageId, tabId, 'Demographics', 'mcoOrgName']">{{ getAttributes("mcoOrgName").label }}
          @if(getAttributes('mcoOrgName').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('mcoOrgName').tooltip}}"
          nzTooltipPlacement="topRight">
          <div [ngClass]="{'error': validationErrors['mcoOrgName'] }">
            <ppl-dropdown-select formControlName="mcoOrgName" id="mcoOrgName" placeholder="Select MCO"
            (selectionChange)="viewerValueChange($event)" [options]="mcoEntries" 
            [optionLabel]="'orgName'" [optionValue]="'orgName'"
            [attr.aria-invalid]="validationErrors['mcoOrgName'] ? 'true' : 'false'"
          [attr.aria-describedby]="validationErrors['mcoOrgName'] ? 'mcoOrgName-error' : null">
            </ppl-dropdown-select>
          </div>
          @if (validationErrors['mcoOrgName']) {
          <span class="pl-1 error-message" id="mcoOrgName-error" role="alert">{{validationErrors['mcoOrgName']}}</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }
    @if(mode==="add" && isAttrAvailable('fiOrgName') && viewerType === 'FI'){
    <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="fiOrgName" class="ppl-form-label"
          [authorizeField]="[pageId, tabId, 'Demographics', 'fiOrgName']">{{ getAttributes("fiOrgName").label }}
          @if(getAttributes('fiOrgName').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('fiOrgName').tooltip}}"
          nzTooltipPlacement="topRight">
          <div [ngClass]="{'error': validationErrors['fiOrgName'] }">
            <ppl-dropdown-select formControlName="fiOrgName" id="fiOrgName" placeholder="Select CDPAP Facilitator"
            (selectionChange)="viewerValueChange($event)" [options]="fiEntries" [optionLabel]="'orgName'" [optionValue]="'orgName'"
            [attr.aria-invalid]="validationErrors['fiOrgName'] ? 'true' : 'false'"
          [attr.aria-describedby]="validationErrors['fiOrgName'] ? 'fiOrgName-error' : null">
            </ppl-dropdown-select>
          </div>
          @if (validationErrors['fiOrgName']) {
          <span class="pl-1 error-message" id="fiOrgName-error" role="alert">{{validationErrors['fiOrgName']}}</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }

    @if(mode==="add" && isAttrAvailable('userId') && viewerForm.get('associationType')){
    <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="userId" class="ppl-form-label"
          [authorizeField]="[pageId, tabId, 'Demographics', 'userId']">{{ getAttributes("userId").label }}
          @if(getAttributes('userId').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('userId').tooltip}}"
          nzTooltipPlacement="topRight">
          <div [ngClass]="{'error': validationErrors['userId'] }">
            <ppl-dropdown-select formControlName="userId" id="userId" placeholder="Select User"
            [disabled]="!users || users.length === 0" [options]="users"
            [optionLabel]="'identifier'" [optionValue]="'userId'"
            [attr.aria-invalid]="validationErrors['userId'] ? 'true' : 'false'"
          [attr.aria-describedby]="validationErrors['userId'] ? 'userId-error' : null">
            </ppl-dropdown-select>
          </div>
          @if (validationErrors['userId']) {
          <span class="pl-1 error-message" id="userId-error" role="alert">{{validationErrors['userId']}}</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }
    @if(mode==="add" && viewerType === 'State') {
    <div nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left"></div>
    }

    @if(isAttrAvailable('associationStartDate')){
    <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">

      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="associationStartDate"
          class="ppl-form-label">{{getAttributes('associationStartDate').label}}
          @if(getAttributes('associationStartDate').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('associationStartDate')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <!-- <nz-date-picker formControlName="associationStartDate" [id]="'associationStartDate'" style="height: 32px;"
              [nzDisabledDate]="disabledStartDate" [nzFormat]="'MM/dd/yyyy'"
              [nzPlaceHolder]="getAttributes('associationStartDate').placeholder"
              [ngClass]="{'error': validationErrors['associationStartDate'] }"></nz-date-picker> -->
            <ppl-date-picker formControlName="associationStartDate" id="associationStartDate" [showIcon]="true"
            [placeholder]="getAttributes('associationStartDate').placeholder" dateFormat="mm/dd/yy"
            [ariaLabel]="getAttributes('associationStartDate').label" [yearRange]="'1900:2050'" [iconDisplay]="'input'"
            inputId="icondisplay" [panelStyleClass]="'custom-calendar-panel'"
            [maxDate]="minStartDate" [styleClass]="validationErrors['associationStartDate'] ? 'error' : ''"
            [attr.aria-invalid]="validationErrors['associationStartDate'] ? 'true' : 'false'"
          [attr.aria-describedby]="validationErrors['associationStartDate'] ? 'associationStartDate-error' : null"></ppl-date-picker>
          </div>
          @if (validationErrors['associationStartDate']) {
          <span class="pl-1 error-message" id="associationStartDate-error" role="alert">{{validationErrors['associationStartDate']}}</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }

    @if(isAttrAvailable('associationEndDate')){
    <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">

      <nz-row>

        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="associationEndDate"
          class="ppl-form-label">{{getAttributes('associationEndDate').label}}
          @if(getAttributes('associationEndDate').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('associationEndDate')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <!-- <nz-date-picker formControlName="associationEndDate" [id]="'associationEndDate'" style="height: 32px;"
              [nzFormat]="'MM/dd/yyyy'" [nzPlaceHolder]="getAttributes('associationEndDate').placeholder"
              [nzDisabledDate]="disabledEndDate"
              [ngClass]="{'error': validationErrors['associationEndDate'] }"></nz-date-picker> -->
              <ppl-date-picker formControlName="associationEndDate" id="associationEndDate" [showIcon]="true"
                [placeholder]="getAttributes('associationEndDate').placeholder" dateFormat="mm/dd/yy"
                [ariaLabel]="getAttributes('associationEndDate').label" [yearRange]="'1900:2050'" [iconDisplay]="'input'"
                inputId="icondisplay" [panelStyleClass]="'custom-calendar-panel'"
                [minDate]="maxEndDate" [styleClass]="validationErrors['associationEndDate'] ? 'error' : ''"
                [attr.aria-invalid]="validationErrors['associationEndDate'] ? 'true' : 'false'"
          [attr.aria-describedby]="validationErrors['associationEndDate'] ? 'associationEndDate-error' : null"></ppl-date-picker>
          </div>
          @if (validationErrors['associationEndDate']) {
          <span class="pl-1 error-message"  id="associationEndDate-error" role="alert">{{validationErrors['associationEndDate']}}</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }
  </form>
</div>
<div class="custom-row">
  <ppl-button label="Cancel" icon="fa fa-ban" [customClass]="'alt-button'" [iconPosition]="'left'"
    (click)="cancelEdit()"></ppl-button>
  <ppl-button label="Save" icon="fa fa-floppy-o" [customClass]="'alt-button'" [iconPosition]="'left'"
    (click)="save()"></ppl-button>
</div>
} @else if(mode==="read"){
@if(leadStatus !== approvedStatus && !(entry === 'referral' && leadStatus === 'Review Complete') && !readOnly) {
<div class="custom-row">

  @if(!disableAddCaseManager) {
  <div class="mr-2">
    <ppl-button label="Add Case Manager" icon="fa fa-plus" [customClass]="'ghost-button'" [iconPosition]="'left'"
      (click)="add('MCO', 'Case Manager')" *authorize="[pageId, tabId, 'Viewer', 'section', 'edit']"></ppl-button>
  </div>
  }

  @if(!disableAddStateStaff) {
  <div class="ml-2">
    <ppl-button label="Add State Staff" icon="fa fa-plus" [customClass]="'ghost-button mr-2'" [iconPosition]="'left'"
      (click)="add('State', 'State Staff')" *authorize="[pageId, tabId, 'Viewer', 'section', 'edit']"></ppl-button>
  </div>
  }

  <div class="ml-2">
    <ppl-button label="Add CDPAP Facilitator/Staff" [ariaLabel]="'Add C D PAP Facilitator/Staff'" icon="fa fa-plus" [customClass]="'ghost-button mr-2'"
      [iconPosition]="'left'" (click)="add('FI', 'FI Staff')"
      *authorize="[pageId, tabId, 'Viewer', 'section', 'edit']"></ppl-button>
  </div>
</div>
}

@if(copyOfGridData.length > 0){
@if(isMobileView){
<div class="card-layout p-0 m-0">
  <div class="card pb-2" *ngFor="let data of copyOfGridData">
    <div class="card-item mt-2">
      <nz-row>
        <div nz-col nzSpan="12" [nzXs]="24">
          <nz-row>
            <strong nz-col nzSpan="12" [nzXs]="11">Association Type: </strong>
            <span nz-col nzSpan="12" [nzXs]="13">{{data.displayAssociationType}}</span>
          </nz-row>
        </div>
      </nz-row>
    </div>

    <div class="card-item">
      <nz-row>
        <div nz-col nzSpan="12" [nzXs]="24">
          <nz-row>
            <strong nz-col nzSpan="12" [nzXs]="11">Entity: </strong>
            <span nz-col nzSpan="12" [nzXs]="13">{{data.viewerValue}}</span>
          </nz-row>
        </div>
      </nz-row>
    </div>

    <div class="card-item">
      <nz-row>
        <div nz-col nzSpan="12" [nzXs]="24">
          <nz-row>
            <strong nz-col nzSpan="12" [nzXs]="11">Start Date: </strong>
            <span nz-col nzSpan="12" [nzXs]="13">{{data.associationStartDate}}</span>
          </nz-row>
        </div>
      </nz-row>
    </div>

    @if(data.associationEndDate) {
    <div class="card-item">
      <nz-row>
        <div nz-col nzSpan="12" [nzXs]="24">
          <nz-row>
            <strong nz-col nzSpan="12" [nzXs]="11">End Date: </strong>
            <span nz-col nzSpan="12" [nzXs]="13">{{data.associationEndDate}}</span>
          </nz-row>
        </div>
      </nz-row>
    </div>
    }
  </div>
</div>
} @else {
<ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="isSectionEditable" [data]="copyOfGridData"
  [disableSelection]="true" [cols]="cols" (gridAction)="action($event)" [gridTitle]="false" [pagination]="false"
  [loadPage]="true" [rowsToDisplay]="100">
</ppl-list-table>
}
}@else {
<nz-row>
  <p tabindex="0">No Data found</p>
</nz-row>
}



}@else if (mode==="read" && !copyOfGridData) {
<nz-row>
  <p tabindex="0">No Data found</p>
</nz-row>
}
@if(!isMobileView) {
<div class="custom-row" style="height: 0.3rem"></div>
}

<div class="filter-panel">
  <ng-template #deleteConfirmationDialog let-cancel="cancel">
    <p>Addition of a new {{staffType}} will end the association with the existing {{staffType}}. Do you want to proceed ahead ?</p>
  </ng-template>
</div>